(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('exportableController', exportableController);

    exportableController.$inject = ['$stateParams', 'datePickerService', 'linkService', 'exportableService', 'economicActivityService', 'dateService'];

    function exportableController($stateParams, datePickerService, linkService, exportableService, economicActivityService, dateService){
        var vm = this;
        vm.reportTypes = getReportTypes();
        vm.filterSalesBook = {
            management: null,
            reportType: null
        }
        vm.reportName = undefined;
        vm.fileUrl = null;
        vm.isDownload = false;

        vm.dateParam = $stateParams.date;
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datePickerOpenStatus = {
            dateSalesBook: false,
            datepickerOptions: {
                mode: 'month',
                minMode: 'month',
                maxMode: 'year',
                minDate: dateService.subtractYears(new Date(),2),
                maxDate: new Date()
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
            vm.closeDownload();
        }

        vm.cancelExportable = function (formGenerateSalesBook) {
            vm.filterSalesBook.management = null;
            vm.filterSalesBook.reportType = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateExportable = function (isValid, formGenerateSalesBook) {
            if(isValid) {
                var date = new Date(vm.filterSalesBook.management);
                var fromDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0 , 0);
                var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
                vm.reportName = vm.filterSalesBook.reportType.label;

                if (vm.filterSalesBook.reportType.code === 'attDetailed') {
                    exportableService.getReportAttDetailedXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                        var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                        vm.fileUrl = URL.createObjectURL(fileTxt);
                        vm.fileName = "reporte_detallado_att_" + Math.round(Date.now() / 1000) +".xlsx";
                        vm.isDownload = true;
                    });
                } else {
                    if (vm.filterSalesBook.reportType.code === 'consolidatedCargo') {
                        exportableService.getReportCargoXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                            var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                            vm.fileUrl = URL.createObjectURL(fileTxt);
                            vm.fileName = "reporte_consolidado_cago_" + Math.round(Date.now() / 1000) +".xlsx";
                            vm.isDownload = true;
                        });
                    } else {
                        if (vm.filterSalesBook.reportType.code === 'consolidatedLuggage') {
                            exportableService.getReportLuggageXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                                var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                vm.fileUrl = URL.createObjectURL(fileTxt);
                                vm.fileName = "reporte_consolidado_equipaje_" + Math.round(Date.now() / 1000) +".xlsx";
                                vm.isDownload = true;
                            });
                        } else {
                            if (vm.filterSalesBook.reportType.code === 'consolidatedPassage') {
                                exportableService.getReportPassageXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                                    var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                    vm.fileUrl = URL.createObjectURL(fileTxt);
                                    vm.fileName = "reporte_consolidado_pasaje_" + Math.round(Date.now() / 1000) +".xlsx";
                                    vm.isDownload = true;
                                });
                            } else {
                                if (vm.filterSalesBook.reportType.code === 'consolidatedProduction') {
                                    exportableService.getReportsProductionXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                                        var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                        vm.fileUrl = URL.createObjectURL(fileTxt);
                                        vm.fileName = "reporte_consolidado_produccion_" + Math.round(Date.now() / 1000) +".xlsx";
                                        vm.isDownload = true;
                                    });
                                } else {
                                    if (vm.filterSalesBook.reportType.code === 'consolidatedSsr') {
                                        exportableService.getReportsSsrXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                                            var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                            vm.fileUrl = URL.createObjectURL(fileTxt);
                                            vm.fileName = "reporte_consolidado_ssr_" + Math.round(Date.now() / 1000) +".xlsx";
                                            vm.isDownload = true;
                                        });
                                    } else {
                                        if (vm.filterSalesBook.reportType.code === 'unusedTicket') {
                                            exportableService.getReportsUnusedTicketXlsxDownload(moment(fromDate).format('yyyy-MM-DD HH:mm:ss'), moment(toDate).format('yyyy-MM-DD HH:mm:ss')).then(function (response) {
                                                var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                                vm.fileUrl = URL.createObjectURL(fileTxt);
                                                vm.fileName = "reporte_boletos_no_usados_" + Math.round(Date.now() / 1000) +".xlsx";
                                                vm.isDownload = true;
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                vm.isDownload = false;
            }
        }

        vm.closeDownload = function() {
            vm.isDownload = false;
        };

        function getReportTypes(){
            // {code: "consolidatedProduction", label: "air.salesBook.reportTypes.consolidatedProduction"},
            return [
                {code: "attDetailed", label: "air.salesBook.reportTypes.attDetailed"},
                {code: "consolidatedCargo", label: "air.salesBook.reportTypes.consolidatedCargo"},
                {code: "consolidatedLuggage", label: "air.salesBook.reportTypes.consolidatedLuggage"},
                {code: "consolidatedPassage", label: "air.salesBook.reportTypes.consolidatedPassage"},
                {code: "consolidatedSsr", label: "air.salesBook.reportTypes.consolidatedSsr"},
                {code: "unusedTicket", label: "air.salesBook.reportTypes.unusedTicket"}
            ];
        }
    }
})();
